<template>
  <div class="app-container">
    <CrudTable
      entity="OrderPickList"
      :columns="columns"
      :generate-summary="generateSummary"
      :on-row-dbl-click="onRowDoubleClick"
      :allow-create="false"
      :show-action-icons-in-list="false"
    />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        {
          field: 'id',
          label: 'common.number',
          width: '150px'
        },
        {
          field: 'domain',
          label: 'common.domain',
          width: '200px',
          filter: {
            type: 'select',
            options: this.$store.getters.domains,
            valueField: 'id',
            labelField: 'name',
            filterName: 'domainID'
          }
        },
        {
          field: 'weekNumber',
          label: 'common.week',
          width: '100px',
          filter: { type: 'none' }
        },
        {
          field: 'year',
          label: 'common.year',
          width: '100px',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'workshopDescription',
          label: 'common.workshop',
          width: '250px',
          filter: {
            type: 'select',
            options: this.$store.getters.workshops,
            valueField: 'id',
            labelField: 'name',
            filterName: 'workshopID'
          }
        },
        {
          field: 'pickedYN',
          label: 'orderPick.picked',
          width: '80px',
          filter: {
            type: 'select',
            options: [
              { value: 'Y', label: this.$t('common.yes') },
              { value: 'N', label: this.$t('common.no') }
            ],
            valueField: 'value',
            labelField: 'label'
          },
          sortable: false
        },
        {
          field: 'seriesNumbers',
          label: 'common.series',
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  methods: {
    generateSummary({ code, description }) {
      let summary = `${code}`;
      if (description) {
        summary += ` (${description})`;
      }
      return summary;
    },
    getColumn(fieldName) {
      return this.columns.find(c => c.field === fieldName);
    },
    onRowDoubleClick(row) {
      const id = row.id;
      this.$router.push({ name: 'CompleteOrderPickList', params: { id } });
    }
  }
};
</script>
